import React from 'react'
import { connect } from 'react-redux'
import { array, object } from 'prop-types'
import { HeaderSection, Challenges, Mission, Curriculum, End, TestimonialsBanner, LargeGrid } from '../../components'
import Speak from './components/Speak/Speak'
import testimonials from '../../../i18n/testimonials.json'
import TranslationContext from '../../../utils/TranslationContext'

class Home extends React.Component {

	static fetchQueries = [
		'services?tag=challenges',
		'business',
		'services?tag=complementary',
		'services?tag=personal-trainer'
		// 'person { name image curriculum results }'
		// 'core_features(tag: "homepage") { title subtitle description } services(tag: "challenges") { id card { title smallDescription frontImage } } }',
		// 'testimonials { title description images}}',
		// 'services (tag: "complementary"){ id card { title }}}'
	]

	static propTypes = {
		services: array,
		business: object,
		testimonials: array,
		complementary: array,
		personalTrainers: array
	}

	static contextType = TranslationContext

	render() {
		const { services, business, complementary, personalTrainers } = this.props
		const { locale } = this.context
		const { slogan, slogans, features, contacts } = (business || {})
		return (
			<div>
				<HeaderSection slogan={ slogan } slogans={ slogans } />
				<Challenges services={ services } />
				<Mission features={ features } />
				<LargeGrid items={ (personalTrainers || []).map((trainer) => ({ ...trainer, to: `/trainers/${ trainer.id }` })) } />
				<TestimonialsBanner testimonials={ testimonials[locale] } />
				<Speak complementary={ complementary } />
				<End contacts={ contacts } />
			</div>
		)
	}
}

const mapStateToProps = state => ({
	services: state.fetch.results[Home.fetchQueries[0]],
	business: state.fetch.results[Home.fetchQueries[1]],
	complementary: state.fetch.results[Home.fetchQueries[2]],
	personalTrainers: state.fetch.results[Home.fetchQueries[3]]
})

export default connect(mapStateToProps)(Home)



// WEBPACK FOOTER //
// ./src/client/website/pages/HomePage/Home.js